<template>
  <div :class="[ loaderClass, 'relative overflow-hidden skeleton-loader']">
    <div class="shimmer absolute top-0 right-0 bottom-0 left-0" />
    <slot />
  </div>
</template>

<script setup lang="ts">
export interface Props {
  type?: string
}
const props = defineProps<Props>()
const loaderClass = props.type === 'circle' ? 'rounded-full' : 'rounded-sm'
</script>
